import { Link } from "react-router-dom";

const CTASharedOne = ({ title, desc1, desc2, desc3, image }) => {
  return (
    <section className="overflow-hidden items-center bg-gray-50 sm:grid sm:grid-cols-2 mt-4">
      <div className="p-8 md:p-8 lg:px-8 lg:py-8">
        <div className="mx-auto max-w-xl text-left ltr:sm:text-left rtl:sm:text-right">
          <h2 className="text-3xl font-bold text-gray-900 md:text-3xl">{title}</h2>

          <p className="hidden text-gray-500 md:mt-4 md:block text-left">{desc1}</p>
          <p className="hidden text-gray-500 md:mt-4 md:block text-left">{desc2}</p>
          <p className="hidden text-gray-500 md:mt-4 md:block text-left">{desc3}</p>

          <div className="mt-4 md:mt-8">
            <Link
              to="/contact"
              className="inline-block rounded bg-primary-light3 px-12 py-3 text-sm font-medium text-white transition hover:bg-primary-light1 focus:outline-none focus:ring focus:ring-yellow-400"
            >
              Get in touch
            </Link>
          </div>
        </div>
      </div>

      <img
        alt="SharedSpace1"
        src={image}
        className="h-full w-full object-cover sm:h-[calc(100%_-_2rem)] sm:self-end sm:rounded-ss-[30px] md:h-[calc(100%_-_4rem)] md:rounded-ss-[60px]"
        width={300}
        height={50}
      />
    </section>
  );
};

export default CTASharedOne;
